import { lazy } from 'react';

const Notifications = lazy(
	() =>
		import(
			/* webpackChunkName: "notifications" */
			'./notifications-container.js'
		)
);

export default Notifications;
